import apiClient from "./client";
import type {
  LicenseIssue,
  LicenseIssueForm,
  UpdateIssueForm,
  ApiResponse,
  ListResponse,
  BatchUpdateIssueParams,
  BatchRevokeIssueParams,
} from "@/types";

const BASE = "/issues";

export interface IssueQueryParams {
  page?: number;
  page_size?: number;
  search?: string;
  logic?: "and" | "or";
  id?: number;
  project_id?: number;
  product_id?: number;
  version_id?: number;
  customer_id?: number;
  status?: string;
  key_format?: string;
  machine_code?: string;
  project_name?: string;
  product_name?: string;
  customer_name?: string;
  issued_at_start?: string;
  issued_at_end?: string;
  expires_at_start?: string;
  expires_at_end?: string;
  created_at_start?: string;
  created_at_end?: string;
}

export async function listIssues(
  params?: IssueQueryParams,
): Promise<ApiResponse<ListResponse<LicenseIssue>>> {
  const { data } = await apiClient.get(BASE, { params });
  return data;
}

export async function getIssue(id: number): Promise<ApiResponse<LicenseIssue>> {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data;
}

export async function createIssue(
  form: LicenseIssueForm,
): Promise<ApiResponse<LicenseIssue>> {
  const { data } = await apiClient.post(BASE, form);
  return data;
}

export async function batchUpdateIssues(
  data: BatchUpdateIssueParams,
): Promise<ApiResponse<LicenseIssue[]>> {
  const { data: res } = await apiClient.patch(BASE, data);
  return res;
}

export async function batchRevokeIssues(
  data: BatchRevokeIssueParams,
): Promise<ApiResponse<LicenseIssue[]>> {
  const { data: res } = await apiClient.post(`${BASE}/batch-revoke`, data);
  return res;
}

export async function updateIssue(
  id: number,
  form: UpdateIssueForm,
): Promise<ApiResponse<LicenseIssue>> {
  const { data } = await apiClient.put(`${BASE}/${id}`, form);
  return data;
}

export async function renewIssue(
  id: number,
): Promise<ApiResponse<LicenseIssue>> {
  const { data } = await apiClient.post(`${BASE}/${id}/renew`);
  return data;
}

export async function revokeIssue(
  id: number,
  reason?: string,
): Promise<ApiResponse<LicenseIssue>> {
  const { data } = await apiClient.post(`${BASE}/${id}/revoke`, { reason });
  return data;
}
